import React from 'react';
import DrIbubeleyeJohnwillMacdonald from "../assets/images/IbubeleyeMacDonaldJohnwill.jpg";
import WallaceMyemAboiyar from "../assets/images/WallaceMyemAboiyar.jpg";
import MiriamNguaveseAnjie from "../assets/images/MiriamNguaveseAnjie.jpg";
import SimonAugustineIdah from "../assets/images/SimonAugustineIdah.jpg";
import GideonIkyernum from "../assets/images/GideonIkyernum.jpg";
import LawanUmarBala from "../assets/images/LawanUmarBala.jpeg";
import OluwasojiSamuel from "../assets/images/OluwasojiSamuel.jpg";

const teamMembers = [
  { name: 'Gideon Ikyernum', role: 'MD', image: GideonIkyernum },
  { name: 'Dr. Ibubeleye Johnwill Macdonald', role: 'Finance', image: DrIbubeleyeJohnwillMacdonald },
  { name: 'Wallace Myem Aboiyar', role: 'Operations', image: WallaceMyemAboiyar },
  { name: 'Miriam Nguavese Anjie', role: 'Legal and Compliance', image: MiriamNguaveseAnjie },
  { name: 'Simon Augustine Idah', role: 'Customer Experience', image: SimonAugustineIdah },
  { name: 'Lawan Umar Bala', role: 'Business Development', image: LawanUmarBala },
  { name: 'Oluwasoji Samuel', role: 'Technology', image: OluwasojiSamuel },
];

export default function OurTeam() {
  return (
    <section className='px-[12%] py-[6%] grid lg:grid-cols-12 gap-10'>
      <div className='lg:col-span-4'>
        <p className='flex color-[#002455] tracking-[0.3rem] uppercase text-[.8rem]'>
          Our Team
          <span className='text-[var(--second-primary-color)] text-2xl leading-[.5] pl-3'>&#8594;</span>
        </p>
        <h3 className='md:pt-10 pt-5 text-[1.2rem] md:text-[1.5rem] text-[#002455] font-[800] leading-[1.3]'>The Best Team</h3>
        <p className='text-[.6rem] text-[#555D68] pt-6'>
          No matter your financial objectives, we're here to provide expert guidance and support every step of the way.
        </p>
      </div>

      <div className='lg:col-span-8 pt-4 text-[.9rem]'>
        <div className='grid md:grid-cols-3 gap-4 grid-cols-2'>
          {teamMembers.map((member, index) => (
            <div key={index} className="team-member">
              <div className='bg-[#D9D7DA]'>
                <img
                  src={member.image}
                  alt={`${member.name}, ${member.role}`}
                  className="team-member-img w-full h-full aspect-[16/20] object-cover transform transition-transform duration-300 ease-in-out hover:scale-105"
                />
              </div>
              <p className='text-[#002455] font-[700]'>{member.name}</p>
              <p className='text-[#70798D]'>{member.role}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
